document.addEventListener('DOMContentLoaded', function() {
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (!document.querySelector("shop-login-button")) {
                console.log("shop-login-button still not found");
                return;
            }
            observer.disconnect(); // Stop observing once we have our element
            addCustomStyle();
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    function addCustomStyle() {
        const customStyle = document.createElement("style");
        customStyle.innerHTML = `
        .follow-icon-wrapper:hover:before {
            background-position: left !important;
            border-color: #303030 !important;
            background-size: 0 100%, 100% 100% !important;
        }
        .follow-icon-wrapper:before {
            --initial-gradient: linear-gradient(transparent, transparent) !important;
            --hover-gradient: linear-gradient(#303030, #303030) !important;
            --initial-background-position: left !important;
            --hover-background-position: right !important;
            background-color: transparent !important;
            background-image: linear-gradient(transparent, transparent), linear-gradient(#303030, #303030) !important;
            background-size: 100% 100%, 0 100% !important;
            background-position: left !important;
            background-repeat: no-repeat !important;
            border-color: #dfdfda !important;
            width: 104% !important;
            transition: background-size .45s cubic-bezier(.785,.135,.15,.86), background-position .45s step-end, border-color .45s cubic-bezier(.785,.135,.15,.86);
        }
        .follow-icon-wrapper:hover shop-heart-icon {
            color: #ffffff !important;
            opacity: 1 !important;
        }
        .follow-icon-wrapper shop-heart-icon {
            color: #303030 !important;
            opacity: .6 !important;
            transition: color .45s cubic-bezier(.785,.135,.15,.86), opacity .45s cubic-bezier(.785,.135,.15,.86);
        }
        .follow-icon-wrapper:hover .follow-text {
            color: #ffffff !important;
        }
        .follow-icon-wrapper .follow-text {
            color: #303030 !important;
            font-family: "Neuzeit Office", sans-serif !important;
            font-size: 13px !important;
            text-transform: uppercase !important;
            transition: color .45s cubic-bezier(.785,.135,.15,.86);
        }
        .follow-icon-wrapper:hover .follow-text shop-logo {
            color: #ffffff !important;
            opacity: 1 !important;
        }
        .follow-icon-wrapper .follow-text shop-logo {
            color: #303030 !important;
            opacity: .6 !important;
            transition: color .45s cubic-bezier(.785,.135,.15,.86), opacity .45s cubic-bezier(.785,.135,.15,.86);
        }
        `;

        const baseElement = document.querySelector("shop-login-button");
        if (baseElement && baseElement.shadowRoot) {
            const followButton = baseElement.shadowRoot.querySelector("shop-follow-button");
            if (followButton && followButton.shadowRoot) {
                const followOnShopButton = followButton.shadowRoot.querySelector("follow-on-shop-button");
                if (followOnShopButton && followOnShopButton.shadowRoot) {
                    const styleElement = followOnShopButton.shadowRoot.querySelector("style");
                    if (styleElement) {
                        styleElement.after(customStyle);
                    } else {
                        console.error('Style element not found');
                    }
                } else {
                    console.error('follow-on-shop-button not found');
                }
            } else {
                console.error('shop-follow-button not found');
            }
        } else {
            console.error('shop-login-button not found');
        }
    }
});
